<template>
  <div class="a_main">
    <ball></ball>
    <div class="nav">
      <Nav :title="navTitle" :flexed="'true'"></Nav>
    </div>
    <div class="tab">
      <div class="tabs_start">
        <div class="tab_text">选择</div>
        <div class="tab_text">日期</div>
      </div>
      <div class="date_select">
        <div class="tab_date">
          <van-tabs
            @change="changDate(active)"
            v-model="active"
            color="#5B8DF6"
            title-active-color="#5B8DF6"
            class="texttab"
          >
            <div class="tabs_flex">
              <div class="tabs_center">
                <van-tab
                  :name="index"
                  v-for="(item, index) in dateList"
                  :key="index"
                  swipeable
                >
                  <template #title>
                    <div>
                      <div class="tab_text">
                        {{ item.date_text | dateFormat }}
                      </div>
                      <div class="tab_text">{{ item.week_text }}</div>
                    </div>
                  </template>
                </van-tab>
              </div>
            </div>
          </van-tabs>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="doc_item">
        <div class="_main">
          <div v-if="!flag">
            <van-empty
              image="https://account.kmmds.top/datainfo_pic/error.png"
              description="暂无排班信息"
            />
          </div>
          <div v-for="(item, key, index) in gh_dypeList" :key="index">
            <!-- <div ref="empytarr"  v-if=" !(new Date().getTime() <=new Date(item[0].visitEndTime.replace(/-/g, '/')).getTime())">
              <van-empty   description="暂无排版信息" />
            </div> -->
            <div
            >
              <div class="_head">
                 <div class="time" v-if="item.Name&&item.Name=='行政班'">
            {{item.Name}} ---08:30-11:30;14:30-17:30                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                </div>
                <div class="time" v-else>
            {{item.Name}} ---{{item.BeginTime.substr(11)}}~{{item.EndTime.substr(11)}}
                </div>
                <!-- <div class="time"></div> -->
              </div>
              <div
                class="card"
                :key="index"
                @click="goghdetail(item)" >
                <div class="context">
                  <div class="icon">
                    <van-image
                    v-if="!item.PersonImage"
                      round
                      fit="fill"
                      height="60px"
                      width="60px"
                      :src="require('../../assets/img/doc_item.png')"
                    />
                      <img v-else :src="imgSrc + item.PersonImage"  class="doc_img"/>
                  </div>
                  <div class="text">
                    <div class="head_text">
                      <div class="head_text_name" v-if="item.DoctorName">
                        {{ item.DoctorName }}
                      </div>
                      <div class="head_text_name" v-else>{{ dypename }}</div>
                    
                      <div class="head_text_btn">{{ item.PersonLevel }}</div>
                    </div> 
                    <div class="text_ltem">{{ dypename }}</div>
                    <!-- 擅长 -->
                    <div class="grey">
                      简介：{{item.PersonIntroduction}}
                    </div>
                  </div>
                </div>
                <div class="doclist_item_foot">
                  <div class="ghf">
                    挂号费:{{ item.Amount ? item.Amount : 0 }}元
                  </div>
                  <!-- <div class="yh">余号：{{ item.appointLimit }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/nav.vue";
export default {
  data() {
    return {
      dypename: "",
      navTitle: "排班列表",
      active: 0,
      dept_deptId: "",
      dype_type_name: "",
      dype_type_key: "",
      dateList: [],
      checkdate: {},
      gh_dypeList: [],
      afternoonList: [],
      flag: true,
      flgaarr: false,
      doctorId: "",
      wx_pub_id: "",
       imgSrc: "data:image/jpeg;base64,",
       dype_type:null
    };
  },
  components: {
    Nav,
  },
  filters: {
    dateFormat(date) {
      return (date = date.substr(5));
    },
  },
  mounted() {
    this.getDateWeek();
    this.getDypeinfo();

    // console.log(this.$refs.empytarr[index])
    // this.gh_dypeList.remove(this.$refs.empytarr)
  },
  methods: {
    //跳转传参
    goghdetail(item) {
      console.log(item)
      if(item.DoctorID=="0"){
      console.log(this.dype_type)
         this.$router.push({
          path: "/details_ymzyy",
          query: {
            deptid:  this.dept_deptId,
            dept_type: JSON.parse(JSON.stringify(this.dype_type)) ,
            regfre:  item.Amount,
             register_level: "N",
          }
        });
        return
      }
      this.$router.push({
        path: "/ylzyy_docdetail",
        query: {
          DoctorID:item.DoctorID,
          DoctorName:item.DoctorName,
          deptid:this.dept_deptId,
          deptName: this.dypename,
          regFee:item.Amount,
         seedate:item.BeginTime
        },
      });
    },
    //切换事件
    changDate(index) {
      // console.log(index);

      this.checkdate = this.dateList[index];

      this.getdypeItem(this.checkdate.date_text);
    },
    async getdypeItem(date) {
      try {
        this.$showLoad();
        let dypeItem_data = {
          InCode:this.dept_deptId,
          Date: date,
        };
        let url = "/register/QueryRegSchedule";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          dypeItem_data,
          (data) => {
          
            this.$hideLoad();
            console.log(data)
            this.gh_dypeList=data.data.data?.List?.Item
            console.log(123, this.gh_dypeList)
              if(!this.gh_dypeList){
             this.flag=false
            }else{
              this.flag=true
               this.gh_dypeList=  this.gh_dypeList.filter(item=>{
               return new Date().getTime()< new Date(item.EndTime.replace(/-/g, '/')).getTime()
             })
            }
            
            
          
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    //接受参数
    getDypeinfo() {
     
        this.dept_deptId = this.$route.query.deptid;
 
        this.dypename= this.$route.query.dept_type.deptName;
        this.dype_type=this.$route.query.dept_type
        // console.log(this.dype_type_name);
        // console.log(this.dype_type_key);
    },
    async getDateWeek() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/getDateWeek";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);
            this.dateList = data.data;
            // this.wx_pub_id = data.wx_pub_id;
            this.changDate(0);
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.a_main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 100vw;
  .tab {
    display: flex;
    //   flex-direction: column;
    justify-content: flex-start;
    margin-top: 10px;
    border-bottom: 1px solid #aaaaaa;
    padding-bottom: 10px;
    .tab_date {
      flex: 1;
    }
    .tab_text {
      text-align: center;
    }
    .tabs_start {
      border-right: 1px solid #aaaaaa;
      width: 15%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .tab_text {
        font-size: 15px;
        color: #646566;
      }
    }
    .date_select {
      //   border:1px solid #990099;
      width: 85%;
    }
  }
  .body {
    max-width: 100%;
    //   height: 100vh;
    //  background-color: yellowgreen;
    flex: 1;
    display: flex;
    overflow: scroll;
    .doc_item {
      flex: 1;
    }
  }
}

._main {
  height: 91vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  ._head {
    height: 40px;
    margin-top: 10px;
    padding-right: 5px;
    padding-left: 5px;
    background-color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #bdc3c7;
    line-height: 25px;
    align-items: center;
    justify-self: center;
    justify-items: center;
    .time {
      line-height: 30px;
      height: 30px;
      padding-left: 15px;
      border-left: 5px solid #5b8df6;
      font-size: 12px;
    }
    .docNum {
      margin-right: 6px;
      line-height: 30px;
      font-size: 12px;
    }
  }
  .card {
    margin: 0px auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 97%;
    margin: 0px auto;
    margin-top: 3px;

    .context {
      margin-top: 8px;
      display: flex;
      flex-direction: row;
      .text {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        width: 80%;
        .head_text {
          display: flex;
          line-height: 25px;

          .head_text_name {
            color: #57606f;
            margin-right: 10px;
            font-size: 16px;
          }
          .head_text_tsxt {
            color: #57606f;
            margin-right: 10px;
            font-size: 12px;
          }
          .head_text_btn {
            line-height: 25px;
            font-size: 10px;
            height: 25px;
            background-color: #5b8df6;
            border-radius: 3px;
            color: white;
          }
        }
        .text_ltem {
          color: #57606f;
          line-height: 25px;
          font-size: 12px;
        }
        .grey {
          font-size: 12px;
          color: #bdc3c7;
          line-height: 20px;
          border-bottom: 1px #bdc3c7 dashed;
        }
      }
      .icon {
        width: 20%;
        height: 75px;
        // transform:scaleX(0.5,0.5);
        //     -webkit-transform:scaleX(0.5,0.5);  /*兼容-webkit-引擎浏览器*/
        //     -moz-transform:scaleX(0.5,0.5);
        .doc_img{
          width: 60px;
          height: 60px;
          border-radius:99px
        }
      }
    }
  }
}
.doclist_item_foot {
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  line-height: 20px;
  .ghf {
    padding-right: 5px;
    font-size: 12px;
    border-right: 1px solid #bdc3c7;
  }
  .yh {
    padding-left: 5px;
    font-size: 12px;
  }
}
</style>